import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { lastValueFrom, map, Observable, take, tap } from 'rxjs';
import { ApiService } from '../services/api.service'
import { Role } from '../models/role';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor( private apiService: ApiService, private router: Router) {
  }
  canActivate( next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.apiService.user$.pipe( 
      take(1),
      map((user: any) => {
        let permisions = {} as any
        const role = user?.role || {} as Role
        for(const p of role.routers || []){ permisions = {...permisions,[p]: true} }
        // for(const p of user?.userData?.global_preferences || []){ permisions = {...permisions,[p]: true} }
        if(!user || !next.data['roles'].some((rol: string) => permisions[rol] === true )) { this.router.navigateByUrl('/auth/error') }
        return user !== undefined
      })
    )
  }
  
}
